module.exports = __webpack_public_path__ + "static/media/col_ico3.c63eaf93.png";